<template>
  <div class="products">
    <mainmenu selected="products"></mainmenu>

    <div class="container">
      <h1>{{ $t("products.page_title") }}</h1>
      
      <p>
        <el-button @click='add_item()'>{{ $t("add_item") }}</el-button>
      </p>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Filters</span>
        </div>
        <div>
          <el-form :inline="true" :model="Filters">
            <el-form-item :label="$t('dashboard.article_code')">
              <el-autocomplete class="inline-input" v-model="Filters.ArticleCode" :fetch-suggestions="queryCodes"></el-autocomplete>
            </el-form-item>

            <el-form-item :label="$t('dashboard.category')" >
              <el-select v-model="Filters.IdCategory">
                <el-option :label="$t('all')" :value="-1" :key="-1"></el-option>
                <el-option v-for="c in Categories" :label="c.Name" :value="c.Id" :key="c.Id"></el-option>
              </el-select>
            </el-form-item>
            
            
            <el-form-item>
              <el-button type="primary" @click="refresh_info">{{$t('filter')}}</el-button>
              <el-button type="warning" @click="reset_filters">{{$t('reset')}}</el-button>
            </el-form-item>
            
          </el-form>
        </div>
      </el-card>

      <el-table :data="Results" style="width: 100%; margin-top: 15px" v-loading="loadingVisible">

        <el-table-column prop="ArticleNumber" :label="$t('products.article_number')" ></el-table-column>
        <el-table-column :label="$t('products.name')">
          <template slot-scope="scope">
            
            <div v-if="scope.row.Approved=='0'" style='color:red'>
              {{scope.row.Name}}
            </div>
            <div v-else>
              {{scope.row.Name}}
            </div>

          </template>
        </el-table-column>
        <el-table-column prop="ProposedByUser" :label="$t('products.proposed_by_user')" ></el-table-column>

        <el-table-column fixed="right" :label="$t('operations')" width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.Approved==0" @click="approve_item(scope.row)" type="text" size="small">{{ $t("products.approve") }}</el-button>
            <el-button @click="edit_item(scope.row)"    type="text" size="small">{{ $t("edit") }}</el-button>
            <el-button @click="delete_item(scope.row)"  type="text" size="small">{{ $t("delete") }}</el-button>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination
          @size-change        = "refresh_info"
          @current-change     = "refresh_info"
          :page-size.sync     = "PaginationInfo.PerPage"
          :current-page.sync  = "PaginationInfo.Page"
          :total              = "PaginationInfo.RowCount"
          layout              = "pager">
      </el-pagination>
    </div>
    <product-dialog ref="item_dialog" @save='refresh_info' />
  </div>
</template>

<script>
import MainMenu from "@/widgets/MainMenu";
import settings from "@/backend/LocalSettings";
import BasePage from '@/views/BasePage';

import ProductDialog from "@/views/dialogs/ProductDialog";

export default {
  name: "products",
  extends: BasePage,
  components: {
    "mainmenu": MainMenu,
    "product-dialog": ProductDialog
  },
  data () {
    return { 
      Categories:[],
      Results: [],
      Filters: { ArticleCode: '', IdCategory: -1 },
      PaginationInfo: { Page: 1, PerPage: 10, RowCount: 0, PageSizes: [10, 25, 50, 100] }
    }
  },
  methods: {
    async get_info(){
      var response        = await this.post('products/get_info' );
      this.Categories     = response.Categories;
      this.refresh_info();
    },
    async refresh_info() {
      var response        = await this.post('products/refresh_info',  { Filters: this.Filters, PaginationInfo: this.PaginationInfo } );
      this.Results        = response.Results;
      this.PaginationInfo = response.PaginationInfo;
    },
    add_item: function(){
      this.$refs.item_dialog.show_me();
    },
    edit_item: function(item){
      this.$refs.item_dialog.show_me(item);
    },
    async approve_item(item) {
        var confirmed = await this.$confirm(this.$t("products.confirm_approve"), this.$t("warning_title"), { 
            confirmButtonText: this.$t("confirm"), 
            cancelButtonText: this.$t("cancel"), 
            type: 'warning'
        });
        if( confirmed) 
        { 
            await this.post('products/approve_item',  { object: item } );
            this.refresh_info();
        };
    },
    async delete_item(item){
       var confirmed = await this.$confirm( this.$t("confirm_delete"), this.$t("warning_title"), { 
         confirmButtonText: this.$t("confirm"), 
         cancelButtonText: this.$t("cancel"), 
         type: 'warning'
        });
        if( confirmed) 
        {
          await this.post('products/delete_item',  { object: item } );
          this.refresh_info();
        }      
    },
    async queryCodes(queryString, cb){
      var response = await this.post('products/search_code',  { query: queryString } );
      cb(response.Results);
    },
    reset_filters(){
      this.Filters = { ArticleCode: '', IdCategory: -1 };
      this.refresh_info();
    }
  },
  mounted: function() {
    this.get_info();
  }
};
</script>

<style lang="less" scoped>

</style>